import {saveAs} from 'file-saver'

export function fileDownload(resp) {
  const fileName = resp.headers['content-disposition'].split('=')[1]
  const file = new File([resp.data], fileName, {
    type: resp.headers['content-type'],
  })
  saveAs(file)
}

export function saveTxt(items, title, onSuccess) {
  const blob = new Blob([items.join('\n')], {
    type: 'text/plain;charset=utf-8',
  })

  try {
    saveAs(blob, `${title}.txt`)
    onSuccess()
  } catch (err) {
    console.error('failed', err)
  }
}
